// Список популярных Google Fonts для выбора шрифта названия сайта
export const googleFonts = [
    { name: 'Inter', value: "'Inter', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Roboto', value: "'Roboto', sans-serif", weights: '300;400;500;700' },
    { name: 'Open Sans', value: "'Open Sans', sans-serif", weights: '300;400;600;700' },
    { name: 'Lato', value: "'Lato', sans-serif", weights: '300;400;700' },
    { name: 'Montserrat', value: "'Montserrat', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Poppins', value: "'Poppins', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Raleway', value: "'Raleway', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Nunito', value: "'Nunito', sans-serif", weights: '300;400;600;700' },
    { name: 'Source Sans Pro', value: "'Source Sans Pro', sans-serif", weights: '300;400;600;700' },
    { name: 'Ubuntu', value: "'Ubuntu', sans-serif", weights: '300;400;500;700' },
    { name: 'Playfair Display', value: "'Playfair Display', serif", weights: '400;500;600;700' },
    { name: 'Merriweather', value: "'Merriweather', serif", weights: '300;400;700' },
    { name: 'Oswald', value: "'Oswald', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Lora', value: "'Lora', serif", weights: '400;500;600;700' },
    { name: 'PT Sans', value: "'PT Sans', sans-serif", weights: '400;700' },
    { name: 'Noto Sans', value: "'Noto Sans', sans-serif", weights: '400;500;600;700' },
    { name: 'Work Sans', value: "'Work Sans', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Crimson Text', value: "'Crimson Text', serif", weights: '400;600;700' },
    { name: 'Fira Sans', value: "'Fira Sans', sans-serif", weights: '300;400;500;600;700' },
    { name: 'Dancing Script', value: "'Dancing Script', cursive", weights: '400;500;600;700' },
    { name: 'Pacifico', value: "'Pacifico', cursive", weights: '400' },
    { name: 'Bebas Neue', value: "'Bebas Neue', cursive", weights: '400' },
    { name: 'Anton', value: "'Anton', sans-serif", weights: '400' },
    { name: 'Righteous', value: "'Righteous', cursive", weights: '400' },
    { name: 'Lobster', value: "'Lobster', cursive", weights: '400' }
];

// Загруженные шрифты (чтобы не загружать повторно)
const loadedFonts = new Set();

/**
 * Динамически загружает шрифт из Google Fonts
 * @param {string} fontName - Название шрифта (например, "Roboto")
 * @param {string} weights - Веса шрифта (например, "300;400;500;700")
 */
export const loadGoogleFont = (fontName, weights = '300;400;500;600;700') => {
    // Если шрифт уже загружен, не загружаем повторно
    if (loadedFonts.has(fontName)) {
        return;
    }

    // Проверяем, есть ли уже ссылка на этот шрифт
    const existingLink = document.querySelector(`link[data-font="${fontName}"]`);
    if (existingLink) {
        loadedFonts.add(fontName);
        return;
    }

    // Создаем ссылку на Google Fonts
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/\s+/g, '+')}:wght@${weights}&display=swap`;
    link.setAttribute('data-font', fontName);
    document.head.appendChild(link);

    loadedFonts.add(fontName);
};

/**
 * Загружает шрифт по его значению (например, "'Roboto', sans-serif")
 * @param {string} fontValue - Значение шрифта из списка googleFonts
 */
export const loadFontByValue = (fontValue) => {
    if (!fontValue) return;

    // Извлекаем название шрифта из значения (убираем кавычки и fallback)
    const fontMatch = fontValue.match(/'([^']+)'/);
    if (!fontMatch) return;

    const fontName = fontMatch[1];
    
    // Находим шрифт в списке для получения весов
    const font = googleFonts.find(f => f.name === fontName);
    if (font) {
        loadGoogleFont(fontName, font.weights);
    } else {
        // Если шрифт не найден в списке, загружаем с дефолтными весами
        loadGoogleFont(fontName);
    }
};

/**
 * Извлекает название шрифта из URL Google Fonts
 * @param {string} url - URL типа https://fonts.google.com/specimen/Titillium+Web
 * @returns {string|null} Название шрифта или null
 */
export const extractFontNameFromUrl = (url) => {
    if (!url) return null;
    
    try {
        // Парсим URL Google Fonts
        // Формат: https://fonts.google.com/specimen/Font+Name
        const match = url.match(/fonts\.google\.com\/specimen\/([^\/\?]+)/);
        if (match) {
            // Заменяем + на пробелы и декодируем URL
            const fontName = decodeURIComponent(match[1].replace(/\+/g, ' '));
            return fontName;
        }
        
        // Если формат другой, пробуем извлечь из пути
        const pathMatch = url.match(/specimen\/([^\/\?]+)/);
        if (pathMatch) {
            const fontName = decodeURIComponent(pathMatch[1].replace(/\+/g, ' '));
            return fontName;
        }
        
        return null;
    } catch (e) {
        console.error('Ошибка парсинга URL шрифта:', e);
        return null;
    }
};

